import { render, staticRenderFns } from "./releaseList.vue?vue&type=template&id=5b42a4f0&scoped=true&"
import script from "./releaseList.vue?vue&type=script&lang=js&"
export * from "./releaseList.vue?vue&type=script&lang=js&"
import style0 from "./releaseList.vue?vue&type=style&index=0&id=5b42a4f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b42a4f0",
  null
  
)

export default component.exports